import { Connection } from '@solana/web3.js';

import { getSolanaSignerConfig } from '../config.js';

const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const SOLANA_RPC_URL = !IS_DEV
  ? 'https://go.getblock.io/1fadfcdc569b4db58cb33e5211641784/'
  : 'https://go.getblock.io/1fadfcdc569b4db58cb33e5211641784/';

export function getSolanaConnection(): Connection {
  const customRPC = getSolanaSignerConfig('customRPC');

  return new Connection(customRPC || SOLANA_RPC_URL, {
    commitment: 'confirmed',
    disableRetryOnRateLimit: false,
  });
}

export const wait = async (time: number) =>
  new Promise((resolve) => setTimeout(resolve, time));
